<template>
  <game-template title="Complétez les phrases suivantes" sub-title="Vous trouverez l'information sur l'interface GTA.">
    <template v-slot:content>
      <gap-fill-game-template v-on:next="next" v-on:validate="validate" :button-enabled="canValidate" :show-error="hasValidate && touched.length === 0" :is-valid="isValid">
        <template v-slot:head>
          <zoomable-image>
            <img src="../assets/gap-fill-game/gap-fill-1.png">
          </zoomable-image>
        </template>
        <template v-slot:content>
          <p>
            <span>Nous sommes mi-mars 2021, je dois poser les</span>
            <gap-filler v-model="gaps.gap1.fill" :gap="gaps.gap1" :show-answers="hasValidate && !isTouched('gap1')" @touched="toggleTouched('gap1')"></gap-filler>
            <span>congés payés restants sinon ils seront perdus</span>
            <span><br>et contrôler si les</span>
            <gap-filler v-model="gaps.gap2.fill" :gap="gaps.gap2" :show-answers="hasValidate && !isTouched('gap2')" @touched="toggleTouched('gap2')"></gap-filler>
            <span>des mois à venir ont été planifiés.</span>
          </p>
          <p>
            <span>Il me reste</span>
            <gap-filler v-model="gaps.gap3.fill" :gap="gaps.gap3" :show-answers="hasValidate && !isTouched('gap3')" @touched="toggleTouched('gap3')"></gap-filler>
            <span>
              à payer ou à faire récupérer à mon collaborateur.
              Le solde affiché est projeté à la fin de l’exercice, est en minutes et est déjà majoré.
            </span>
          </p>
          <p>
            <span>Le salarié a déjà bénéficié d’un</span>
            <gap-filler v-model="gaps.gap4.fill" :gap="gaps.gap4" :show-answers="hasValidate && !isTouched('gap4')" @touched="toggleTouched('gap4')"></gap-filler>
            <span>de 3,56h à 150% et de 13h et 45 minutes de</span>
            <gap-filler v-model="gaps.gap5.fill" :gap="gaps.gap5" :show-answers="hasValidate && !isTouched('gap5')" @touched="toggleTouched('gap5')"></gap-filler>
            <span>depuis le début de l’année.</span>
          </p>
        </template>
      </gap-fill-game-template>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import GapFillGameTemplate from '@shared/components/GapFillGameTemplate'
import GapFiller from '@shared/components/GapFiller'
import gapFillMixin from '@shared/mixins/gapFillMixin'

export default {
  name: 'GapFill1',
  mixins: [stepMixin, gapFillMixin],
  components: {
    GapFillGameTemplate,
    GapFiller
  },
  data () {
    return {
      gaps: {
        gap1: {
          fill: '',
          choices: ['25', '7', '4'],
          goodChoice: '4'
        },
        gap2: {
          fill: '',
          choices: ['CP', 'MALADIE', 'RTT'],
          goodChoice: 'RTT'
        },
        gap3: {
          fill: '',
          choices: ['12h et 57 minutes', '7h', '168h'],
          goodChoice: '12h et 57 minutes'
        },
        gap4: {
          fill: '',
          choices: ['paiement', 'récupération'],
          goodChoice: 'paiement'
        },
        gap5: {
          fill: '',
          choices: ['paiement', 'récupération'],
          goodChoice: 'récupération'
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>
